<template>
  <TimeslotDashboardLayout>
    <template v-slot:mobile-navbar>
      <div
        data-collapse="medium"
        data-animation="over-left"
        data-duration="400"
        data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab25c"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        class="navbar-mobile w-nav"
      >
        <div class="navbar1_container">
          <a href="#" class="navbar1_logo-link w-nav-brand">
            <img
              src="@/assets/timeslot-images/bookaslot-logo.svg"
              loading="lazy"
              alt=""
              class="navbar1_logo"
          /></a>

          <div
            @click="showNav"
            class="navbar1_menu-button w-nav-button"
            style="-webkit-user-select: text;"
            aria-label="menu"
            role="button"
            tabindex="0"
            aria-controls="w-nav-overlay-0"
            aria-haspopup="menu"
            aria-expanded="false"
          >
            <div class="menu-icon1">
              <div class="menu-icon1_line-top"></div>
              <div class="menu-icon1_line-middle">
                <div class="menu-icon_line-middle-inner"></div>
              </div>
              <div class="menu-icon1_line-bottom"></div>
            </div>
          </div>
        </div>
        <div
          v-if="cross"
          class="w-nav-overlay"
          data-wf-ignore=""
          id="w-nav-overlay-0"
          style="height: 100vh; display: block; width: 100%;"
        >
          <nav
            role="navigation"
            class="navbar1_menu w-nav-menu"
            style="transform: translateX(0px) translateY(0px);  height: 100vh; transition: transform 400ms ease 0s;"
            data-nav-menu-open=""
          >
            <div class="div-block-4-copy top">
              <a
                data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab262"
                href="#"
                class="link-block-3 w-inline-block"
                @click="closeNav"
              >
                <img
                  src="@/assets/timeslot-images/cancel.svg"
                  loading="lazy"
                  alt=""
                />
              </a>
              <div class="div-block-51">
                <div class="div-block-5-copy">
                  <div class="div-block-6-copy">
                    <div class="text-block-8">SO</div>
                  </div>
                  <div class="div-block-28">
                    <div class="text-block-6">Seun Orofin</div>
                    <div class="text-block-7">
                      <router-link to="/professional-profile" class="link-18"
                        >View profile</router-link
                      >
                    </div>
                  </div>
                </div>
                <div class="div-block-29">
                  <router-link
                    to="/professional-dashboard"
                    aria-current="page"
                    class="link-block-4 dashboard w-inline-block w--current"
                  >
                    <div class="text-block-27">Dashboard</div>
                  </router-link>
                  <router-link
                    to="/professional-messages"
                    class="link-block-4 message w-inline-block"
                  >
                    <div class="text-block-27">Messages</div>
                  </router-link>
                  <router-link
                    to="/professional-bookings"
                    class="link-block-4 booking w-inline-block"
                  >
                    <div class="text-block-27">Bookings</div>
                  </router-link>
                  <router-link
                    to="/professional-feeds"
                    class="link-block-4 feeds w-inline-block"
                  >
                    <div class="text-block-27">Feeds</div>
                  </router-link>
                  <router-link
                    to="/professional-wallet"
                    class="link-block-4 wallet w-inline-block"
                  >
                    <div class="text-block-27">Wallet</div>
                  </router-link>
                  <router-link
                    to="/professional-settings"
                    class="link-block-4 settings w-inline-block"
                  >
                    <div class="text-block-27">Settings</div>
                  </router-link>
                </div>
                <div class="div-block-29-copy">
                  <router-link
                    to="/professional-support"
                    class="link-block-4 support w-inline-block"
                  >
                    <div class="text-block-27">Support</div>
                  </router-link>
                  <router-link
                    to="/login"
                    class="link-block-4 log-out w-inline-block"
                  >
                    <div class="text-block-27">Log out</div>
                  </router-link>
                </div>
              </div>
            </div>
            <div></div>
          </nav>
        </div>
      </div>
    </template>
    <template v-slot:app-navbar>
      <ProfessionalAppNavBar />
    </template>
    <template v-slot:sidebar>
      <ProfessionalSidebar />
    </template>
    <div class="main-content">
      <div class="welcome-wrappr">
        <div class="text-block-43">Feeds</div>
      </div>
      <div class="empty-message-container">
        <img src="@/assets/timeslot-images/feeds.svg" width="50" height="50" />
        <div class="new-message">Nothing to show here</div>
        <div class="new-message-sub">
          Appointments with professionals <br />
          would show up here
        </div>
        <router-link
          to="/discover-professionals"
          class="timeslot-button w-button"
          >Discover professionals</router-link
        >
      </div>

      <!--      <div class="post-feeds-wrapper">-->
      <!--        <img-->
      <!--          src="@/assets/timeslot-images/ugokamsi.png"-->
      <!--          loading="lazy"-->
      <!--          width="67"-->
      <!--          alt=""-->
      <!--          class="feeds-profile-image"-->
      <!--        />-->
      <!--        <a-->
      <!--          data-w-id="389fdd8e-c630-4d98-102e-96c38736a015"-->
      <!--          href="#"-->
      <!--          class="post-feeds-button w-button"-->
      <!--          >What would you like to share?</a-->
      <!--        >-->
      <!--      </div>-->
      <!--      <div class="feeds-wrapper">-->
      <!--        <div class="div-block-3">-->
      <!--          <div class="feeds-profile-image"></div>-->
      <!--          <div>-->
      <!--            <div class="text-block-44">Seun Orofin</div>-->
      <!--            <div class="text-block-7">-->
      <!--              <a href="#" class="link-2">Product Designer</a>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="header">-->
      <!--          <div class="feeds-caption">-->
      <!--            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sit-->
      <!--            tincidunt aliquam justo, orci adipiscing aliquam proin vitae, sit.-->
      <!--            Fringilla adipiscing eget donec in purus neque, arcu, diam,-->
      <!--            dignissim. Iaculis convallis feugiat sed pellentesque duis mauris.-->
      <!--            At massa diam tellus felis mi aenean etiam. Tristique aenean-->
      <!--            ullamcorper tincidunt ante vel.-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="feeds-footer">-->
      <!--          <div class="feeds-action-wrapper">-->
      <!--            <a href="#" class="feeds-action w-inline-block"-->
      <!--              ><img-->
      <!--                src="@/assets/timeslot-images/like.svg"-->
      <!--                loading="lazy"-->
      <!--                id="like-button"-->
      <!--                alt=""-->
      <!--              />-->
      <!--              <div class="feeds-action-counter">0</div>-->
      <!--            </a>-->
      <!--            <a href="#" class="feeds-action w-inline-block"-->
      <!--              ><img-->
      <!--                src="@/assets/timeslot-images/dislike.svg"-->
      <!--                loading="lazy"-->
      <!--                alt=""-->
      <!--              />-->
      <!--              <div class="feeds-action-counter">0</div>-->
      <!--            </a>-->
      <!--            <a-->
      <!--              data-w-id="1f904bd5-198b-ee22-1836-695b7d40e19b"-->
      <!--              href="#"-->
      <!--              class="feeds-action w-inline-block"-->
      <!--              @click="openShare"-->
      <!--              ><img-->
      <!--                src="@/assets/timeslot-images/Group-36577.svg"-->
      <!--                loading="lazy"-->
      <!--                id="myDIV"-->
      <!--                alt=""-->
      <!--            /></a>-->
      <!--          </div>-->
      <!--          <div class="feeds-time-stamp">Posted 2 hours ago</div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="feeds-wrapper">-->
      <!--        <div class="div-block-3">-->
      <!--          <div class="feeds-profile-image"></div>-->
      <!--          <div>-->
      <!--            <div class="text-block-44">Seun Orofin</div>-->
      <!--            <div class="text-block-7">-->
      <!--              <a href="#" class="link-2">Product Designer</a>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="header">-->
      <!--          <div class="feeds-caption">-->
      <!--            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sit-->
      <!--            tincidunt aliquam justo, orci adipiscing aliquam proin vitae, sit.-->
      <!--            Fringilla adipiscing eget donec in purus neque, arcu, diam,-->
      <!--            dignissim. Iaculis convallis feugiat sed pellentesque duis mauris.-->
      <!--            At massa diam tellus felis mi aenean etiam. Tristique aenean-->
      <!--            ullamcorper tincidunt ante vel.-->
      <!--          </div>-->
      <!--          <div class="feeds-media">-->
      <!--            <img-->
      <!--              src="@/assets/timeslot-images/image-5.png"-->
      <!--              loading="lazy"-->
      <!--              width="675"-->
      <!--              sizes="100vw"-->
      <!--              srcset="-->
      <!--                ../../../assets/timeslot-images/image-5-p-500.png   500w,-->
      <!--                ../../../assets/timeslot-images/image-5-p-800.png   800w,-->
      <!--                ../../../assets/timeslot-images/image-5-p-1080.png 1080w,-->
      <!--                ../../../assets/timeslot-images/image-5.png        1350w-->
      <!--              "-->
      <!--              alt=""-->
      <!--            />-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="feeds-footer">-->
      <!--          <div class="feeds-action-wrapper">-->
      <!--            <div class="feeds-action">-->
      <!--              <img-->
      <!--                src="https://uploads-ssl.webflow.com/6299c6ac6dd7d329873685ae/6299c6ac6dd7d32b5b368620_like.svg"-->
      <!--                loading="lazy"-->
      <!--                id="like-button"-->
      <!--                alt=""-->
      <!--              />-->
      <!--              <div class="feeds-action-counter">0</div>-->
      <!--            </div>-->
      <!--            <div class="feeds-action">-->
      <!--              <img-->
      <!--                src="https://uploads-ssl.webflow.com/6299c6ac6dd7d329873685ae/6299c6ac6dd7d36baf36862f_dislike.svg"-->
      <!--                loading="lazy"-->
      <!--                alt=""-->
      <!--              />-->
      <!--              <div class="feeds-action-counter">0</div>-->
      <!--            </div>-->
      <!--            <img-->
      <!--              src="https://uploads-ssl.webflow.com/6299c6ac6dd7d329873685ae/6299c6ac6dd7d3c7f0368621_Group%2036577.svg"-->
      <!--              loading="lazy"-->
      <!--              id="myDIV"-->
      <!--              alt=""-->
      <!--            />-->
      <!--          </div>-->
      <!--          <div class="feeds-time-stamp">Posted 2 hours ago</div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <template v-slot:right-side-nav>
      <ProfRightSideMenu />
    </template>
    <ShareModal v-if="share" :cancel="closeShare" />
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
import ProfessionalAppNavBar from "@/components/navbar/ProfessionalAppNavBar";
import ProfessionalSidebar from "@/views/timeslot/ProfessionalSidebar";
import ProfRightSideMenu from "@/views/timeslot/ProfRightSideMenu";
import ShareModal from "@/components/modal/ShareModal";
export default {
  name: "ProfessionalFeeds",
  components: {
    TimeslotDashboardLayout,
    ProfessionalAppNavBar,
    ProfessionalSidebar,
    ProfRightSideMenu,
    ShareModal
  },
  data() {
    return {
      share: false,
      bar: true,
      cross: false
    };
  },
  methods: {
    openShare() {
      this.share = true;
    },
    closeShare() {
      this.share = false;
    },
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    }
  }
};
</script>

<style scoped></style>
